export default {
  /** ALERT */
  WARNING: "WARNING",
  SUCCESS: "SUCCESS",
  DANGER: "DANGER",
  INFO: "INFO",
  PROCESS: "PROCESS",
  LOAD: "LOAD",
  COPIED: "COPIED",

  /** AUTH */
  SIGN_IN: "SIGN_IN",
  SIGN_OUT: "SIGN_OUT",
  LOCKSCREEN: "LOCKSCREEN",
  SIGN_UP: "SIGN_UP",
  AUTH_BUFFER: "AUTH_BUFFER",

  /** RIGHT SIDE BTN */
  RIGHT_SEARCH_BTN: "RIGHT_SEARCH_BTN",
  RIGHT_ADD_BTN: "RIGHT_ADD_BTN",
  RIGHT_SAVE_BTN: "RIGHT_SAVE_BTN",
  RIGHT_DETAIL_BTN: "RIGHT_DETAIL_BTN",
  RIGHT_EDIT_BTN: "RIGHT_EDIT_BTN",
  RIGHT_DELETE_BTN: "RIGHT_DELETE_BTN",
  RIGHT_APPROVE_BTN: "RIGHT_APPROVE_BTN",
  RIGHT_REJECT_BTN: "RIGHT_REJECT_BTN",
  CLEAR_RIGHT_BTN: "CLEAR_RIGHT_BTN",
  RIGHT_RUN_BTN: "RIGHT_RUN_BTN",
  RIGHT_DISBURSE_BTN: "RIGHT_DISBURSE_BTN",

  // BLOCK REDUCER
  CURRENT_TEMPLATE: "CURRENT_TEMPLATE",
};
